interface NotificationClasses {
    main: string;
    wrapper: string;
    meta: string;
    icon: string;
    status: (status: string) => void;
    dismissible: string;
    closeButtonContainer: string;
    closeButton: string;
}

export enum NotificationType {
    INFO = 'info',
    SUCCESS = 'success',
    WARNING = 'warning',
    ERROR = 'error',
    GREETING = 'greeting',
}

export enum NotificationPosition {
    top = 't',
    topRight = 'tr',
}

export interface NotificationMessage {
    id: string;
    title: string;
    message: string;
    status: NotificationType;
    position: NotificationPosition;
    dismissAfter: number;
    dismissible: boolean;
    closeButton: boolean;
    allowHTML: boolean;
}

export type NotificationMessageAction = Pick<NotificationMessage, 'title'> & Partial<Omit<NotificationMessage, 'title'>>;

export interface NotificationProps {
    className: NotificationClasses;
    notification: NotificationMessage;
}

export interface NotificationPositionsProps {
    theme: NotificationTheme;
}

export interface NotificationsContainerProps {
    notifications: NotificationMessage[];
    position: string;
    theme: NotificationTheme;
}

export interface NotificationTheme {
    smallScreenPosition: NotificationPosition.top;
    notificationsSystem: {
        className: string;
    };
    notificationsContainer: {
        className: {
            main: string;
            position?: (position: string) => string;
        };
        transition: {
            name: {
                enter: string;
                leave: string;
            };
            enterTimeout: number;
            leaveTimeout: number;
        };
    };
    notification: {
        className: NotificationClasses;
    };
}
